const GET_CATALOG_ITEM = 'GET_CATALOG_ITEM';
const SET_CATALOG_ITEM = 'SET_CATALOG_ITEM';
const GET_CATALOG_SPECIFICATION_BY_SUBTYPE = 'GET_CATALOG_SPECIFICATION_BY_SUBTYPE';
const SET_CATALOG_SPECIFICATION_BY_SUBTYPE = 'SET_CATALOG_SPECIFICATION_BY_SUBTYPE';

const GET_IS_CATALOG_ITEM_VALID_DELETE = 'GET_IS_CATALOG_ITEM_VALID_DELETE';
const SET_IS_CATALOG_ITEM_VALID_DELETE = 'SET_IS_CATALOG_ITEM_VALID_DELETE';

const GET_IS_VEHICLE_LEVEL_VALID_DELETE = 'GET_IS_VEHICLE_LEVEL_VALID_DELETE';
const SET_IS_VEHICLE_LEVEL_VALID_DELETE = 'SET_IS_VEHICLE_LEVEL_VALID_DELETE';

const GET_IS_EQ_CLASS_VALID_DELETE = 'GET_IS_EQ_CLASS_VALID_DELETE';
const SET_IS_EQ_CLASS_VALID_DELETE = 'SET_IS_EQ_CLASS_VALID_DELETE';

const GET_SAVE_MULTIPLE_CATALOG_STATUS = 'GET_SAVE_MULTIPLE_CATALOG_STATUS';
const SET_SAVE_MULTIPLE_CATALOG_STATUS = 'SET_SAVE_MULTIPLE_CATALOG_STATUS';

export
{
    GET_CATALOG_ITEM,
    SET_CATALOG_ITEM,
    GET_CATALOG_SPECIFICATION_BY_SUBTYPE,
    SET_CATALOG_SPECIFICATION_BY_SUBTYPE,
    GET_IS_CATALOG_ITEM_VALID_DELETE,
    SET_IS_CATALOG_ITEM_VALID_DELETE,
    GET_IS_VEHICLE_LEVEL_VALID_DELETE,
    SET_IS_VEHICLE_LEVEL_VALID_DELETE,
    GET_IS_EQ_CLASS_VALID_DELETE,
    SET_IS_EQ_CLASS_VALID_DELETE,
    GET_SAVE_MULTIPLE_CATALOG_STATUS,
    SET_SAVE_MULTIPLE_CATALOG_STATUS
};